// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import mapValuesToHasFields from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/mapValuesToHasFields";

const setBreakpointTitle = (breakpoint: number) => `${breakpoint}px`;

/**
 * A function that maps the given values to a the given breakpoint
 *
 * @param values - The values to map
 * @param breakpoint - The breakpoint to map the values to
 * @returns - The default values fields mapped by breakpoint
 */
export const mapValuesPerBreakpoint = (values: HasFields["fields"], breakpoint: number) => {
    const defaultValuesFields: HasFields = {
        fields: {},
    };

    defaultValuesFields.fields.breakpoint = setBreakpointTitle(breakpoint);

    mapValuesToHasFields(values, {
        overridedDefaultValuesObj: defaultValuesFields,
    });

    return defaultValuesFields;
};
